<template>
  <div class="">
    <van-action-sheet v-model="show" title="Thông tin đơn hàng">
      <div class="content">
        <div class="page_pay_choose">
          <div class="page_pay_info">
            <div class="page_pay_choose_title">
              <div class="page_pay_choose_title_left">Giỏ hàng</div>
            </div>
            <div class="page_pay_info_list" v-if="shopData.product_id">
              <div class="page_pay_info_img">
                <img :src="shopData.product_img" alt="" />
              </div>
              <div class="page_pay_info_list_text">
                <div class="page_pay_info_list_top">
                  {{ shopData.product_name }}
                </div>
                <div class="page_pay_info_list_bottom">
                  {{ shopData.need_pay }} VND
                </div>
              </div>
              <div class="page_pay_info_right">
                <div class="page_pay_info_right_bg">
                  <div>x1</div>
                </div>
              </div>
            </div>
            <div class="page_pay_info_noData" v-else>Đơn hàng đang trống</div>
            <div class="page_pay_choose_pmt">
              <div class="page_pay_choose_title">
                <div class="page_pay_choose_title_left">
                  Phương thức thanh toán
                </div>
              </div>
              <div class="page_pay_channel">
                <div class="channel_list">
                  <div
                    v-for="(item, index) in atm"
                    :key="index"
                    class="channel_item"
                    :class="{
                      channel_active: selectedIndex === index,
                      'disabled-item': item.disabled,
                    }"
                    @click="item.disabled ? () => {} : selectItem(index)"
                  >
                    <div class="channel-icon">
                      <span>{{ item.name }}</span>
                    </div>
                    <div v-if="item.disabled" class="channel_disabled">
                      Không khả dụng
                    </div>
                    <input
                      v-else
                      type="radio"
                      :name="item.name"
                      :value="index"
                      v-model="selectedIndex"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="page_pay_choose_pmt">
              <div class="page_pay_choose_title">
                <div class="page_pay_choose_title_left">
                  Chi tiết thanh toán
                </div>
              </div>
              <div class="page_pay_detail">
                <div class="page_pay_detail_left">Tổng tiền:</div>
                <div class="page_pay_detail_right">
                  {{ shopData.need_pay }} VND
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="model_bottom">
        <div class="page_pay_confirm">
          <div class="page_pay_confirm_info">
            <div class="page_pay_confirm_info_left">Tổng thanh toán</div>
            <div class="page_pay_confirm_info_right">
              {{ shopData.need_pay }} VND
            </div>
          </div>
          <div class="page_pay_confirm_att">
            Bằng việc nhấn nút “Thanh toán ngay”, bạn đồng ý rằng giao dịch này
            không hoàn, không hủy và tuân thủ với
            <a
              target="_blank"
              href="https://privacy.mgol.vn"
              style="color: rgb(34, 160, 234); text-decoration: underline"
              >Chính sách bảo mật</a
            >
            của MGOL.
          </div>
          <div class="page_pay_confirm_btn">
            <el-button
              type="primary"
              class="page_login_btns"
              :disabled="
                !(shopData.need_pay && atmData.name && $parent.isLogin)
              "
              @click="handleClick"
            >
              Thanh toán ngay
            </el-button>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      show: false,
      shopData: {},
      atmData: {},
      atm: [],
      selectedIndex: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    selectItem(index) {
      this.selectedIndex = index;
      this.atmData = this.atm[this.selectedIndex];
      this.$parent.atmData = this.atmData;
    },
    handleClick() {
      this.$parent.handleConfirm();
    },
  },
};
</script>

<style scoped lang="scss">
.van-action-sheet {
  max-height: 90%;
}
.van-action-sheet__header {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px 0px;
  font-size: 1.25rem;
  font-weight: bold;
}
.content {
  padding: 16px 16px 0;
  height: 50vh;
  overflow: auto;
}
.page_pay_info_list_bottom {
  color: #f05c22;
}
.noData {
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  flex: 1 1 0%;
  overflow: auto;
  padding: 16px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  font-style: italic;
  color: rgb(137, 123, 118);
}
.model_bottom {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.05) 0px -4px 12px 0px;
}

.page_pay_confirm_info {
  margin-top: 8px;
}
</style>
